export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13989.287d7007.jpg";